import { FC } from "react";
import { useSelector } from "react-redux";

import { EventSchedule, ScheduleFilterType } from "Bands/containers";
import { eventBlockSelectorCreator } from "Bands/state";
import { EventBlocks, IScheduleBlock } from "Bands/types";
import { mapUserPermissions } from "shared/utils";

interface EventScheduleBlockProps {
  blockId: string;
  filterType?: ScheduleFilterType;
}

export const EventScheduleBlock: FC<EventScheduleBlockProps> = ({
  blockId,
  filterType,
}) => {
  const scheduleBlockSelector = eventBlockSelectorCreator(
    blockId,
    EventBlocks.schedule
  );
  const scheduleBlock = useSelector(scheduleBlockSelector) as IScheduleBlock;

  return (
    <EventSchedule
      showFilter={
        mapUserPermissions(scheduleBlock.permissions || []).VIEW_FULL_SCHEDULE
      }
      filterType={filterType}
      blockId={blockId}
      entries={scheduleBlock?.entries}
    />
  );
};
